import { render, staticRenderFns } from "./SpectroRadionuclideInput.vue?vue&type=template&id=8f60cc34&scoped=true"
import script from "./SpectroRadionuclideInput.vue?vue&type=script&lang=ts"
export * from "./SpectroRadionuclideInput.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f60cc34",
  null
  
)

export default component.exports